import React from 'react';
import { Flame, Users, Sparkles, CloudSun } from 'lucide-react';
import { mockData } from '../../mock';
import { Reveal, SectionHeader } from './Shared';

const ACTION_IMG = 'https://customer-assets.emergentagent.com/job_ace-padel/artifacts/mvdi8kf9_WhatsApp%20Image%202025-11-03%20at%2016.05.53_f61beec0.jpg';

export const NlWhyPadel = () => (
  <section id="why-padel" data-testid="nl-why-padel" className="nl-section relative">
    <div className="nl-glow w-[30rem] h-[30rem] bg-sky-600/10 -left-40 top-20" />
    <div className="nl-container">
      <SectionHeader
        label="Why Padel"
        title={<>Easy to start.<br />Impossible to quit.</>}
        lead="Part tennis, part squash, all fun. Padel is the fastest-growing racquet sport on the planet — and the easiest to fall in love with."
      />

      <div className="mt-14 grid md:grid-cols-6 gap-4 auto-rows-[minmax(11rem,auto)]">
        <Reveal className="nl-card md:col-span-4 md:row-span-2 relative overflow-hidden min-h-[22rem]">
          <img src={ACTION_IMG} alt="Tournament action at space#" className="nl-img-cover absolute inset-0 opacity-70" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B0D11] via-[#0B0D11]/50 to-transparent" />
          <div className="absolute bottom-0 left-0 p-8">
            <Sparkles className="w-6 h-6 text-amber-500 mb-4" />
            <h3 className="text-2xl md:text-3xl font-extrabold uppercase leading-none">Rallying on<br />day one</h3>
            <p className="text-slate-300 mt-3 max-w-md text-sm md:text-base">
              Smaller court, underarm serve and walls you can play off. Most beginners are enjoying full rallies within their first hour.
            </p>
          </div>
        </Reveal>

        <Reveal delay={1} className="nl-card md:col-span-2 p-7 flex flex-col justify-between">
          <Flame className="w-6 h-6 text-orange-500" />
          <div>
            <div className="nl-display text-5xl font-black leading-none">600<span className="text-amber-500">+</span></div>
            <div className="text-xs uppercase tracking-[0.18em] text-slate-400 font-bold mt-2">kcal burned per hour</div>
            <p className="text-slate-400 text-sm mt-3">A full-body cardio session disguised as a game.</p>
          </div>
        </Reveal>

        <Reveal delay={2} className="nl-card md:col-span-2 p-7 flex flex-col justify-between">
          <Users className="w-6 h-6 text-sky-400" />
          <div>
            <div className="nl-display text-5xl font-black leading-none">2<span className="text-amber-500">v</span>2</div>
            <div className="text-xs uppercase tracking-[0.18em] text-slate-400 font-bold mt-2">Always doubles</div>
            <p className="text-slate-400 text-sm mt-3">Built for socialising. Bring three friends — or come alone and we'll find you a game.</p>
          </div>
        </Reveal>

        <Reveal delay={3} className="nl-card md:col-span-3 p-7 flex items-center gap-6">
          <CloudSun className="w-10 h-10 text-amber-500 shrink-0" />
          <div>
            <h4 className="font-bold text-lg">Indoor &amp; outdoor courts</h4>
            <p className="text-slate-400 text-sm mt-1">Monsoon or midsummer — our Kakkanad indoor venue keeps the game on, all year round.</p>
          </div>
        </Reveal>

        <Reveal delay={4} className="nl-card md:col-span-3 p-7 flex items-center gap-6 border-amber-500/30 bg-amber-500/5">
          <div className="nl-display text-5xl font-black text-amber-500 leading-none shrink-0">#1</div>
          <div>
            <h4 className="font-bold text-lg">Fastest-growing sport worldwide</h4>
            <p className="text-slate-400 text-sm mt-1">Over 25 million players and counting. Kerala's community is growing every week at space#.</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export const NlFacilities = () => (
  <section id="facilities" data-testid="nl-facilities" className="nl-section pt-0">
    <div className="nl-container">
      <div className="grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-4 lg:sticky lg:top-32">
          <SectionHeader
            label="Facilities"
            title="World-class, down to the surface."
            lead="Every space# court is built to professional specification so the only thing you focus on is the next point."
          />
        </div>
        <div className="lg:col-span-8 grid sm:grid-cols-3 gap-4">
          {mockData.features.map((f, i) => (
            <Reveal key={f.title} delay={i} className="nl-card p-7 flex flex-col gap-6 min-h-[16rem]">
              <div className="flex items-center justify-between">
                <span className="text-amber-500">{f.icon}</span>
                <span className="nl-display text-slate-600 font-bold text-sm">0{i + 1}</span>
              </div>
              <div className="mt-auto">
                <h4 className="font-bold text-lg">{f.title}</h4>
                <p className="text-slate-400 text-sm mt-2 leading-relaxed">{f.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
